import React, { useState } from 'react';
import { api } from '@/lib/auth';
import { gaEvent } from '@/lib/analytics';
import { getAttribution } from '@/lib/attribution';

const INTERESTS = [['car', 'Car'], ['bike', 'Bike'], ['pet', 'Pet'], ['valuables', 'Bags & valuables'], ['society', 'Society / RWA'], ['business', 'My business']];

// "Stay in touch" form: stores an email or mobile number only after the visitor ticks the consent box.
const LeadCapture = ({ interest = 'car', source, className = '' }) => {
  const [contact, setContact] = useState('');
  const [want, setWant] = useState(interest);
  const [consent, setConsent] = useState(false);
  const [website, setWebsite] = useState('');           // honeypot, hidden from people
  const [state, setState] = useState({ busy: false, done: false, error: '' });

  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, done: false, error: '' });
    const a = getAttribution() || {};
    try {
      await api.post('/leads', { contact, interest: want, consent, website, source: source || window.location.pathname, utm_source: a.utm_source, utm_campaign: a.utm_campaign });
      gaEvent('generate_lead', { source: 'lead_form', page: source || window.location.pathname });
      setState({ busy: false, done: true, error: '' });
    } catch (err) {
      setState({ busy: false, done: false, error: err.response?.data?.error || 'Something went wrong. Please try again.' });
    }
  };

  return (
    <section className={`bg-white rounded-3xl shadow-sm p-6 sm:p-8 ${className}`} aria-labelledby="lead-heading">
      <h2 id="lead-heading" className="text-2xl font-bold text-gray-800 mb-1">Not ready yet? Stay in touch</h2>
      <p className="text-gray-600 text-sm mb-5">Leave your email or WhatsApp number and we will send you how DotLink works. Nothing else, and you can opt out any time.</p>
      {state.done ? (
        <p className="rounded-2xl bg-green-50 text-green-800 px-4 py-3 text-sm font-semibold" role="status">Thank you! We will be in touch soon.</p>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              value={contact} onChange={(e) => setContact(e.target.value)} required
              type="text" inputMode="email" autoComplete="email" aria-label="Email or mobile number" placeholder="Email or 10-digit mobile"
              className="flex-1 rounded-full border border-gray-200 px-5 py-3 text-sm outline-none focus:border-indigo-400"
            />
            <select value={want} onChange={(e) => setWant(e.target.value)} aria-label="I am interested in" className="rounded-full border border-gray-200 px-4 py-3 text-sm bg-white">
              {INTERESTS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
            <input value={website} onChange={(e) => setWebsite(e.target.value)} tabIndex={-1} autoComplete="off" aria-hidden="true" className="hidden" name="website" />
            <button disabled={state.busy || !consent} className="btn-press rounded-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold px-7 py-3 text-sm disabled:opacity-50">
              {state.busy ? 'Sending…' : 'Keep me posted'}
            </button>
          </div>
          <label className="flex items-start gap-2 text-xs text-gray-500">
            <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5" />
            <span>I agree that DotLink may contact me about its product by email or WhatsApp. See the <a href="/privacy" className="text-indigo-600 underline">privacy policy</a>.</span>
          </label>
          {state.error && <p className="text-xs text-red-600" role="alert">{state.error}</p>}
        </form>
      )}
    </section>
  );
};

export default LeadCapture;
